import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=71173c8a&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=ts"
export * from "./EventDetails.vue?vue&type=script&lang=ts"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=71173c8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71173c8a",
  null
  
)

export default component.exports